import {
  CLAIM_LEVEL_HICAPS_CONNECT_RESPONSE_CODE_MAP,
  CLAIM_LEVEL_HICAPS_CONNECT_RESPONSE_SUCCESS_CODES,
  IResponseCodeInfo,
  ITEM_LEVEL_HICAPS_CONNECT_RESPONSE_CODE_MAP,
} from '@principle-theorem/hicaps-connect';

const TERMINAL_APPROVED_RESPONSE_CODE = '00';

export class HicapsConnectResponseCodes {
  static findResponseCode(responseCode: string): IResponseCodeInfo | undefined {
    return CLAIM_LEVEL_HICAPS_CONNECT_RESPONSE_CODE_MAP[responseCode];
  }

  static isClaimSuccessful(responseCode: string): boolean {
    return CLAIM_LEVEL_HICAPS_CONNECT_RESPONSE_SUCCESS_CODES.includes(
      responseCode
    );
  }

  /**
   * HICAPS answers an enumeration request with a success envelope even when it
   * never reached the terminal, e.g. `FC — Could not find Terminal on Network`
   * carrying an empty list. Only `00` means the terminal itself answered.
   * Deliberately stricter than `isClaimSuccessful`, whose extra codes carry
   * claim-settlement meaning that says nothing about terminal reachability.
   */
  static isTerminalResponseSuccessful(responseCode?: string): boolean {
    return responseCode === TERMINAL_APPROVED_RESPONSE_CODE;
  }

  static findServiceItemResponseCode(
    responseCode: string
  ): IResponseCodeInfo | undefined {
    return ITEM_LEVEL_HICAPS_CONNECT_RESPONSE_CODE_MAP[responseCode];
  }
}
